import { CacheHandler } from '@ember-data/store';
import { getOwner, setOwner } from '@ember/owner';
import { LegacyNetworkHandler } from '@ember-data/legacy-compat';
import { service } from '@ember/service';
import ENV from 'tio-employee/config/environment';
import Fetch from '@ember-data/request/fetch';
import RequestManager from '@ember-data/request';
import SessionService from 'tio-employee/services/session';
import Store from 'ember-data/store';
import { timeZone } from 'tio-common/utils/date/time-zone';
import { generateRequestId } from 'tio-common/utils/request-id';
import type { RequestContext, NextFn } from '@ember-data/request';

class AuthHandler {
  @service declare session: SessionService;

  async request<T>(context: RequestContext, next: NextFn<T>) {
    const { request } = context;
    const headers = new Headers(request.headers);

    // Add API headers
    headers.append('Content-Type', 'application/json');
    headers.append('x-api-key', ENV.apiKey);
    headers.append('Time-Zone', timeZone());
    headers.append('X-Request-Id', generateRequestId());

    // Add auth token if logged in
    if (this.session?.isAuthenticated && this.session.data?.authenticated?.access_token) {
      headers.set('tio-auth-token', this.session.data.authenticated.access_token);
    }

    return next({ ...request, headers });
  }
}

export default class AppStore extends Store {
  // @ts-expect-error: need to do more research on how to type this properly
  constructor(...args) {
    super(...args);

    const owner = getOwner(this);
    const authHandler = new AuthHandler();
    // @ts-expect-error: need to do more research on how to type this properly
    setOwner(authHandler, owner);
    this.requestManager = new RequestManager()
      .use([LegacyNetworkHandler, authHandler, Fetch])
      .useCache(CacheHandler);
  }
}
